import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "../lib/api";
import { itemTransform, BoardItemContent } from "../components/moodboard/boardItem";

export default function MoodboardPublic() {
  const { shareId } = useParams();
  const [board, setBoard] = useState(undefined);

  useEffect(() => {
    api.get(`/moodboards/public/${shareId}`).then((r) => setBoard(r.data)).catch(() => setBoard(null));
  }, [shareId]);

  if (board === undefined) return <div className="min-h-screen flex items-center justify-center bg-zinc-100"><span className="w-6 h-6 border-2 border-zinc-300 border-t-zinc-900 rounded-full animate-spin" /></div>;
  if (board === null) return <div className="min-h-screen flex items-center justify-center bg-zinc-100 text-zinc-500 text-sm">This board is private or no longer exists.</div>;

  return (
    <div className="min-h-screen bg-zinc-200 py-10">
      <div className="max-w-5xl mx-auto px-4">
        <div className="mb-4 flex items-end justify-between">
          <div>
            <p className="text-[11px] uppercase tracking-[0.25em] text-zinc-500">Moodboard</p>
            <h1 className="font-heading text-2xl md:text-3xl font-bold text-zinc-900">{board.name}</h1>
            {board.theme && <p className="text-sm text-zinc-500">{board.theme}</p>}
          </div>
          <span className="text-[11px] text-zinc-400">by {board.owner_name} · Lumina AI</span>
        </div>
        <div className="w-full overflow-auto bg-white rounded-lg shadow-xl">
          <div className="relative mx-auto" style={{ width: board.canvas_w, height: board.canvas_h, background: board.background }}>
            {(board.items || []).map((it) => (
              <div key={it.id} style={itemTransform(it)}><BoardItemContent it={it} /></div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
